<template>
  <div class="qty mt-5" :class="classes">
    <button @click="onClick()">{{ Text }}</button>
  </div>
</template>

<script>
import("./style.css");

export default {
  name: "Button",
  props: {
    value: {
      type: Number,
      default: 1,
    },
    Text: {
      type: String,
      default: "Click here",
    },
    classes: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClick() {
      // this.$emit("onClick");
    },
  },
};
</script>
